<template>
    <v-container grid-list-md class="form-user-payment">
        <v-layout row wrap>
            <v-flex md12>
                <v-form>
                    <v-layout align-center row class="pa-0">
                        <v-flex xs12>

                            <v-card>
                                <v-card-title>
                                    Lịch sử nạp thẻ điện thoại:
                                    <v-spacer></v-spacer>
                                </v-card-title>
                                <div id="fb-post-activity-log">
                                    <v-data-table
                                            :headers="headers"
                                            :items="desserts"
                                            :options.sync="options"
                                            :server-items-length="totalDesserts"
                                            :loading="loading"
                                            class="elevation-1"
                                    >
                                        <template v-slot:item.coin="{ item }">
                                                {{ item.coin }}
                                        </template>
                                        <template v-slot:item.denomination="{ item }">
                                                {{ item.denomination | currency }}
                                        </template>
                                        <template v-slot:item.coin="{ item }">
                                            {{ item.coin | currency_init }}
                                        </template>
                                        <template v-slot:item.status_name="{ item }">
                                            <v-chip v-if="item.status==1 " color="teal" dark>
                                                {{ item.status_name }}
                                            </v-chip>
                                            <v-chip v-if="item.status==2" color="success" dark>
                                                {{ item.status_name }}
                                            </v-chip>
                                            <v-chip v-if="item.status==99" color="dark" dark>
                                                {{ item.status_name }}
                                            </v-chip>
                                        </template>
                                    </v-data-table>
                                </div>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    // import { COLOR } from "~/config/constant";
    // import {FB_POST_GET_LIST_ORDER, FB_POST_GET_LIST_REACTION, FB_POST_GET_LIST_SEEDING } from "../../store/actions.type";
    import {AUTH_GET_HISTORY_RECHARGE } from "../../store/actions.type";

    export default {
        data () {
            return {
                search:'',
                totalDesserts: 0,
                desserts: [],
                loading: true,
                options: {},
                headers: [
                    { text: 'ID', value: 'id', align: "center"},
                    { text: 'Thời Gian', value: 'created_at', align: "center"  },
                    { text: 'Nhà mạng', value: 'telecom', align: "center"  },
                    { text: 'Seri', value: 'seri' , align: "center"  },
                    { text: 'Mã thẻ cào', value: 'card_number', align: "center"  },
                    { text: 'Mệnh giá', value: 'denomination' , align: "center"  },
                    { text: 'Số coin nhận', value: 'coin' , align: "center"  },
                    { text: 'Trạng thái', value: 'status_name' , align: "center"  },
                    { text: 'Ghi chú', value: 'note' , align: "center"  },
                ],
                balanceCurrent: 0,
                balanceWithdraw: 0,
                flag: false,
            }
        },
        created() {

        },
        watch: {
            options: {
                handler () {
                    this.getDataFromApi()
                        .then(data => {
                            this.desserts = data.items
                            this.totalDesserts = data.total
                        })
                },
                deep: true,
            },

            // search() {
            //     this.getDataFromApi()
            //         .then(data => {
            //             this.desserts = data.items,
            //                 this.totalDesserts = data.total
            //         });
            //
            // }
        },
        mounted () {
            this.getDataFromApi()
                .then(data => {
                    this.desserts = data.items,
                        this.totalDesserts = data.total
                });
        },
        methods: {
            async getDataFromApi () {
                this.loading = true
                const { sortBy, sortDesc, page, itemsPerPage } = this.options

                let data =  await this.$store.dispatch(AUTH_GET_HISTORY_RECHARGE);
                let items =  data.cardPhoneLogs;

                const total = items.length

                if (sortBy.length === 1 && sortDesc.length === 1) {
                    items = items.sort((a, b) => {
                        const sortA = a[sortBy[0]]
                        const sortB = b[sortBy[0]]

                        if (sortDesc[0]) {
                            if (sortA < sortB) return 1
                            if (sortA > sortB) return -1
                            return 0
                        } else {
                            if (sortA < sortB) return -1
                            if (sortA > sortB) return 1
                            return 0
                        }
                    })
                }

                if (itemsPerPage > 0) {
                    items = items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
                }
                this.loading = false;
                return {items,total};

            },
        },
    }
</script>
<style lang="scss">
    .div-icon-action{
        i {
            cursor: pointer;
        }
    }
</style>
